<i class="control-icon ion ion-ios-search"
   (click)="showInput()"></i>
<input placeholder="Type your search request here..."
       #input
       [class.hidden]="!isInputShown"
       (blur)="hideInput()"
       (input)="onInput($event)">
